import { useEffect, useState } from "react";

import JobInfo from "../../Match/CardDetails/Buttons/JobInfo";
import JobInfoReal from "./Buttons/JobInfoReal";

function CardDetailsJobRev(props: any) {

    const getInfojob = async() => {
        props.setJobInfo(true);
    }

    const backDetails = () => {
        props.setJobInfos([])
        props.setTimeJobInfo(false)
        props.setDetails(false);
    }
    
    const getBack = () => {
        props.setIsMatchingRealRevResult(false);
    }

    useEffect(() => {
        props.setJobInfo(true);
      }, [])

    return (
        <div>
            <div id='CardDetailsSlot-4'>
            <div className='home-btn-slot-3'>
                <i className='bx bx-home bx-sm bx-border' id='home-btn-4' onClick={getBack}>
                    <span className='home-btn-text-2'>
                    Torna alla schermata Home
                    </span>
                </i>
            </div>
            <div className='home-btn-slot-4'>
                <i className='bx bx-sm bx-border' id='home-btn-2' onClick={backDetails}>
                    <span className='home-btn-text-2'>
                    {"◂ Torna ai Risultati"}
                    </span>
                </i>
            </div>
        </div>
            <div className="center-div">
                <button className="cta-red-mat" onClick={getInfojob}>
                                {"Info Offerta"}
                </button>
            </div>
            
            <JobInfoReal job_id={props.jobID} jobInfos={props.jobInfos} setJobInfos={props.setJobInfos}></JobInfoReal>

            </div>
        
    )
}

export default CardDetailsJobRev;